import startCase from 'lodash-es/startCase';

export const SMART_POPUNDERS_OPTIMIZATION_TYPES = [
  'signupsRate',
  'verificationsRate',
  'firstbuysRate',
  'weightedConversion',
];

export const SMART_POPUNDERS_OPTIMIZATION_TYPES_OPTIONS =
  SMART_POPUNDERS_OPTIMIZATION_TYPES.map((item) => ({
    value: item,
    label: startCase(item),
  }));

export const SMART_POPUNDERS_STOP_REASON_OPTIONS = [
  ...SMART_POPUNDERS_OPTIMIZATION_TYPES_OPTIONS,
  {
    value: 'other',
    label: 'Other',
  },
];

export const SMART_POPUNDER_ITERATION_STATUSES = {
  FINISHED: 'finished',
  STARTED: 'started',
  STOPPED: 'stopped',
};
